<template>
  <Flex w-full>
    <Flex column panel :class="{ collapsed: menuCollapsed }">
      <Flex logo>
        <router-link to="/main" class="logo-link">
          <img :src="logoPath('SAI360_Logo_White')" class="logo-image full" />
          <img :src="logoPath('SAI360_Logo_Collapsed_White')" class="logo-image small" />
        </router-link>
      </Flex>
      <MainMenu ref="mainMenu" :collapsed="menuCollapsed" @mainMenuLoaded="menuLoaded = true" />
      <Flex grow @click="hideMenu()">
        <Flex collapse-section>
          <Flex collapse-button @click="menuCollapsed = !menuCollapsed"></Flex>
        </Flex>
      </Flex>
    </Flex>
    <Flex grow>
      <iframe :src="framePath" id="e360Frame" class="w-full h-full" v-if="menuLoaded" />
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex.vue'
import MainMenu from '@/components/menu/MainMenu.vue'

export default {
  name: 'E360Container',

  components: {
    Flex,
    MainMenu,
  },

  props: {
    path: String,
  },

  data() {
    return {
      menuCollapsed: true,
      menuLoaded: false,
    }
  },

  computed: {
    framePath() {
      const urlPath = this.path.length > 1 ? this.path : '/main'
      return `${process.env.VUE_APP_E360_BASE_URL}.${urlPath}`
    },
  },

  mounted() {
    window.addEventListener(
      'message',
      (evt) => {
        if (evt.data.notify === 'url-changed') {
          const newPath = `#/${evt.data.smartUrl}`
          if (evt.data.replace === true) {
            window.history.replaceState(null, null, newPath)
          } else {
            window.history.pushState(null, null, newPath)
          }
          return
        }
        if (evt.data.notify === 'title-changed') {
          document.title = evt.data.title
          return
        }
        if (evt.data.notify === 'e360-clicked') {
          this.hideMenu()
          return
        }
        if (evt.data.notify === 'open-url') {
          window.open(`${process.env.VUE_APP_E360_BASE_URL}${evt.data.url}`).focus()
          return
        }
        if (evt.data.notify === 'shortcuts-changed') {
          this.$refs.mainMenu.updateShortcuts(evt.data.shortcuts)
        }
        if (evt.data.notify === 'mysettings-data-request') {
          this.$refs.mainMenu.postMySettingsData()
        }
      },
      false,
    )
  },

  methods: {
    logoPath(image) {
      return `${process.env.VUE_APP_E360_BASE_URL}images/${image}.svg`
    },
    hideMenu() {
      this.$refs.mainMenu.hideMenu()
    },
  },
}
</script>

<style scoped lang="postcss">
.panel {
  @apply w-64 bg-gray-800 text-white text-sm font-normal;
  transition: 0.5s;
}
.panel.collapsed {
  @apply w-16;
}
.logo {
  @apply relative mb-3;
  transition: 1s;
  height: 50px;
  margin-top: 3px;
}
.logo-link {
  @apply flex w-full h-full ml-2 items-center;
}
.logo-image {
  @apply ml-2 mb-1;
  height: 24px;
}
.logo-image.full,
.panel.collapsed .logo-image.small {
  @apply block;
}
.logo-image.small,
.panel.collapsed .logo-image.full {
  @apply hidden;
}
.collapse-section {
  @apply h-12 self-end w-full relative pb-4 pt-3 border-t border-gray-700;
}
.collapse-button {
  @apply rounded-full absolute right-0 mr-5 w-6 h-6 bg-gray-100 cursor-pointer;
}
.collapse-button:before {
  @apply text-gray-700 text-3xl;
  content: '\00AB';
  position: absolute;
  top: -0.8rem;
  left: 0.275rem;
}
.panel.collapsed .collapse-button:before {
  content: '\00BB';
}
</style>
